import { createTheme, alpha } from '@mui/material/styles';
import type {} from '@mui/x-data-grid/themeAugmentation';

const primary = '#1f4fd1';

export const theme = createTheme({
  cssVariables: { colorSchemeSelector: 'class' },
  colorSchemes: {
    light: {
      palette: {
        primary: { main: primary },
        secondary: { main: '#0f766e' },
        background: { default: '#f5f7fb', paper: '#ffffff' },
        divider: '#e3e8f0',
        text: { primary: '#101828', secondary: '#475467' },
      },
    },
    dark: {
      palette: {
        primary: { main: '#7aa2ff' },
        secondary: { main: '#5eead4' },
        background: { default: '#0b1220', paper: '#111a2e' },
      },
    },
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily: '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    h1: { fontSize: '1.75rem', fontWeight: 650 },
    h2: { fontSize: '1.5rem', fontWeight: 650 },
    h3: { fontSize: '1.25rem', fontWeight: 600 },
    h4: { fontSize: '1.125rem', fontWeight: 600 },
    h5: { fontSize: '1rem', fontWeight: 600 },
    h6: { fontSize: '0.95rem', fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
    subtitle2: { color: '#475467' },
  },
  components: {
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiPaper: { defaultProps: { elevation: 0 }, styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiCard: { defaultProps: { variant: 'outlined' } },
    MuiTextField: { defaultProps: { size: 'small', fullWidth: true } },
    MuiSelect: { defaultProps: { size: 'small' } },
    MuiFormControl: { defaultProps: { size: 'small', fullWidth: true } },
    MuiChip: { styleOverrides: { root: { fontWeight: 600 } } },
    MuiTableCell: { styleOverrides: { head: { fontWeight: 600 } } },
    MuiTooltip: { defaultProps: { arrow: true } },
    MuiDataGrid: {
      defaultProps: { density: 'compact', disableRowSelectionOnClick: true },
      styleOverrides: {
        root: ({ theme: t }) => ({ border: `1px solid ${t.palette.divider}`, backgroundColor: t.palette.background.paper }),
        columnHeaders: ({ theme: t }) => ({ backgroundColor: alpha(t.palette.primary.main, 0.04) }),
      },
    },
  },
});
